import ApplicationLayoutBodyBanner from '@rio-cloud/rio-uikit/components/applicationLayout/ApplicationLayoutBodyBanner';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { FeatureToggles, useFeatureToggle } from '../../../configuration/featureToggle/toggleHook';

export const IncidentBanner: FunctionComponent = () => {
    const { value: isIncident } = useFeatureToggle(FeatureToggles.INCIDENT);

    if (isIncident) {
        return (
            <ApplicationLayoutBodyBanner
                backgroundColor="bg-danger"
                className="padding-5 display-flex justify-content-center width-100pct"
            >
                <span className="text-size-16">
                    <span className="rioglyph rioglyph-truck-breakdown text-size-18 margin-right-5" />
                    <FormattedMessage id="outboundOrderBook.incidentMessage" />
                </span>
            </ApplicationLayoutBodyBanner>
        );
    }
};
